
import { Suspense } from 'react';
import { useSEO } from '../../utils/seo';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogDirectory from './components/BlogDirectory';
import BlogContent from './components/BlogContent';

export default function TrashTalkPage() {
  useSEO({
    title: 'Trash Talk Blog | El Paso Waste Management Tips & Guides',
    description: 'Your ultimate guide to waste management in El Paso! Expert tips on dumpster rentals, junk removal, recycling, and proper waste disposal for homes and businesses in El Paso, Texas.',
    keywords: 'El Paso waste management, trash disposal tips, dumpster rental guide, junk removal El Paso, waste disposal blog, recycling El Paso, business waste solutions',
    canonical: 'https://elpasowastedisposal.com/trash-talk/',
    type: 'blog',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      '@id': 'https://elpasowastedisposal.com/trash-talk/#blog',
      'name': 'Trash Talk - El Paso Waste Management Blog',
      'description': 'Expert tips and guides about waste management, dumpster rentals, and junk removal in El Paso, Texas',
      'url': 'https://elpasowastedisposal.com/trash-talk/',
      'publisher': {
        '@type': 'LocalBusiness',
        '@id': 'https://elpasowastedisposal.com/#business',
        'name': 'El Paso Waste Disposal',
        'telephone': '915-233-1754',
        'address': {
          '@type': 'PostalAddress',
          'addressLocality': 'El Paso',
          'addressRegion': 'TX',
          'postalCode': '79901',
          'addressCountry': 'US'
        }
      }
    }
  });

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <Suspense fallback={<div className="min-h-screen" />}>
          <BlogDirectory />
          <BlogContent />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
